import React from 'react';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import Services1 from './../Elements/Services1';
import About3 from './../Elements/About3';
import Statistics1 from './../Elements/Statistics1';
import Testimonials2 from './../Elements/Testimonials2';

var bnrimg = require('./../../images/banner/9.jpg');

class Service2 extends React.Component {
    render() {
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Banner title="Nos Service  " pagename="Services 2" description="Chacun de nos services est réalisé de manière professionnelle  ." bgimage={bnrimg}/>
                    <Services1 />
                    
                </div>

                <Footer />
            </>
        );
    };
};

export default Service2;